import React from 'react';

export function TasksTypeAndStatusColumnFormatter(cellContent) {
  const {taskType, taskTypeID, taskStatus, taskStatusID} = cellContent;
  const getStatus = () => {
    switch (taskStatusID) {
      case 2:
        return (
          <div
            className="badge badge-pill w-175px font-size-h4 text-nowrap"
            style={{
              background: '#F2E6E6',
              border: '1px solid rgb(239, 65, 48)',
              color: 'rgb(239, 65, 48)',
            }}
          >
            {taskStatus}
          </div>
        );
      case 1:
        return (
          <div
            className="badge badge-pill w-175px font-size-h4 text-nowrap"
            style={{
              background: '#CDEADB',
              border: '1px solid rgb(65, 141, 88)',
              color: 'rgb(65, 141, 88)',
            }}
          >
            {taskStatus}
          </div>
        );
      default:
        return null;
    }
  };
  const getType = () => {
    switch (taskTypeID) {
      case 2:
        return (
          <div
            className="badge badge-pill w-175px font-size-h4 text-nowrap"
            style={{
              background: '#F9F4E5',
              border: '1px solid rgb(253, 185, 19)',
              color: 'rgb(253, 185, 19)',
            }}
          >
            {taskType}
          </div>
        );
      case 1:
        return (
          <div
            className="badge badge-pill w-175px font-size-h4 text-nowrap"
            style={{
              background: '#E3F0FB',
              border: '1px solid rgb(56, 189, 248)',
              color: 'rgb(56, 189, 248)'
            }}
          >
            {taskType}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <div className={'mb-2'}>{getType()}</div>
      <div>{getStatus()}</div>
    </div>
  );
}
